/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ConfirmAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function ConfirmAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/PrintPDF/Content/ConfirmAction",
  isSubmitting,
  onSubmit
  
}) {
let printPdfSubmitData = fromData.useDataSubmit({ viewPath,
context: 'print_pdf',
})
let printPdfIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'print_pdf',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="print_pdf"
 disabled={printPdfIsSubmittingData}
 onClick={printPdfSubmitData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Confirm"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}